import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import CrmBoardView from '../../CrmBoardView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/crm/board'),
      name: 'crm_board',
      component: CrmBoardView,
      meta: {
        featureFlag: FEATURE_FLAGS.CRM,
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
  ],
};
